import React, { useState } from 'react';
import { submitContactMessage } from '../../services/publicEventsApi';
import './ContactPage.css';

const SUBJECT_OPTIONS = [
  { value: '', label: 'Choisissez un sujet' },
  { value: 'Un évènement', label: 'Un événement' },
  { value: 'Un remboursement', label: 'Un remboursement' },
  { value: "J'ai perdu mon billet", label: "J'ai perdu mon billet" },
  { value: 'Tarifs', label: 'Tarifs' },
  { value: 'Annulation / remboursement', label: 'Annulation / remboursement' },
  { value: 'Autres', label: 'Autres' },
  {
    value: 'Je sollicite les services de Mboapass',
    label: 'Je sollicite les services de Mboapass',
  },
];

const ContactMain = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess(false);

    if (!name.trim() || !email.trim() || !phone.trim() || !message.trim()) {
      setError('Veuillez renseigner votre nom, email, téléphone et message.');
      return;
    }
    if (!subject) {
      setError('Veuillez choisir le sujet de votre demande.');
      return;
    }
    if (message.trim().length < 10) {
      setError('Votre message doit contenir au moins 10 caractères.');
      return;
    }

    setSubmitting(true);
    try {
      await submitContactMessage({
        name: name.trim(),
        email: email.trim(),
        phone: phone.trim(),
        subject,
        message: message.trim(),
      });
      setSuccess(true);
      setName('');
      setEmail('');
      setPhone('');
      setSubject('');
      setMessage('');
    } catch (err) {
      setError(
        err?.message ||
          'Impossible d’envoyer votre message. Réessayez plus tard.',
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="contact-page">
      <section className="contact-one">
        <div className="container">
          <div className="contact-one__inner">
            <div className="contact-one__header">
              <h2 className="contact-one__title">Une question, un besoin ?</h2>
              <p className="contact-one__text">
                Écrivez-nous, nous vous répondrons sous 24 à 48 heures.
              </p>
            </div>

            <form
              className="contact-one__form"
              onSubmit={handleSubmit}
              noValidate
            >
              <div className="row">
                <div className="col-xl-6 col-lg-6">
                  <div className="contact-one__input-box">
                    <label className="contact-one__label" htmlFor="contact-name">
                      Nom complet<span className="req">*</span>
                    </label>
                    <input
                      id="contact-name"
                      type="text"
                      name="name"
                      placeholder="Ex. Jean Dupont"
                      autoComplete="name"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      required
                      disabled={submitting}
                    />
                  </div>
                </div>
                <div className="col-xl-6 col-lg-6">
                  <div className="contact-one__input-box">
                    <label className="contact-one__label" htmlFor="contact-email">
                      Email<span className="req">*</span>
                    </label>
                    <input
                      id="contact-email"
                      type="email"
                      name="email"
                      placeholder="vous@exemple.com"
                      autoComplete="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                      disabled={submitting}
                    />
                  </div>
                </div>
                <div className="col-xl-6 col-lg-6">
                  <div className="contact-one__input-box">
                    <label className="contact-one__label" htmlFor="contact-phone">
                      Téléphone<span className="req">*</span>
                    </label>
                    <input
                      id="contact-phone"
                      type="tel"
                      name="phone"
                      placeholder="+237 6XX XXX XXX"
                      autoComplete="tel"
                      value={phone}
                      onChange={(e) => setPhone(e.target.value)}
                      required
                      disabled={submitting}
                    />
                  </div>
                </div>
                <div className="col-xl-6 col-lg-6">
                  <div className="contact-one__input-box">
                    <label className="contact-one__label" htmlFor="contact-subject">
                      Sujet<span className="req">*</span>
                    </label>
                    <select
                      id="contact-subject"
                      name="subject"
                      value={subject}
                      onChange={(e) => setSubject(e.target.value)}
                      required
                      disabled={submitting}
                    >
                      {SUBJECT_OPTIONS.map((opt) => (
                        <option key={opt.value || 'empty'} value={opt.value}>
                          {opt.label}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="col-xl-12">
                  <div className="contact-one__input-box text-message-box">
                    <label className="contact-one__label" htmlFor="contact-message">
                      Message<span className="req">*</span>
                    </label>
                    <textarea
                      id="contact-message"
                      name="message"
                      placeholder="Décrivez votre demande…"
                      value={message}
                      onChange={(e) => setMessage(e.target.value)}
                      required
                      disabled={submitting}
                      rows={5}
                    />
                  </div>

                  {error ? (
                    <div className="contact-one__alert contact-one__alert--error" role="alert">
                      {error}
                    </div>
                  ) : null}
                  {success ? (
                    <div
                      className="contact-one__alert contact-one__alert--success"
                      role="status"
                    >
                      Merci ! Votre message a bien été envoyé. Nous vous répondrons
                      rapidement.
                    </div>
                  ) : null}

                  <div className="contact-one__btn-box">
                    <button
                      type="submit"
                      className="thm-btn contact-one__btn"
                      disabled={submitting}
                    >
                      {submitting ? 'Envoi en cours…' : 'Envoyer le message'}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </section>

      <section className="contact-two">
        <div className="container">
          <div className="row">
            <div className="col-xl-4 col-lg-4">
              <div className="contact-two__single">
                <div className="contact-two__icon">
                  <span className="icon-pin"></span>
                </div>
                <h3 className="contact-two__title">Emplacement</h3>
                <p className="contact-two__text">Yaoundé, Cameroun</p>
              </div>
            </div>

            <div className="col-xl-4 col-lg-4">
              <div className="contact-two__single">
                <div className="contact-two__icon">
                  <span className="icon-paper-plan"></span>
                </div>
                <h3 className="contact-two__title">Email</h3>
                <p className="contact-two__text">
                  <a href="mailto:contact@mboapass.com">contact@mboapass.com</a>
                </p>
              </div>
            </div>

            <div className="col-xl-4 col-lg-4">
              <div className="contact-two__single">
                <div className="contact-two__icon">
                  <span className="icon-call"></span>
                </div>
                <h3 className="contact-two__title">Téléphone</h3>
                <p className="contact-two__text">
                  <a href="tel:+237656301229">+237 656 301 229</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactMain;
